/* eslint-disable import/order */
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { serviceDeskServiceDetailsWithoutProjectRoute } from '@jira/router-routes__servicedesk-services-routes/src/serviceDeskServiceDetailsWithoutProjectRoute.tsx';
import ServicedeskServiceDetailsWithoutProjectContext, {
	LazyServicedeskServiceDetailsWithoutProjectContext,
} from './ui/service-details-without-project-context/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const serviceDeskServiceDetailsWithoutProjectRouteEntry: Route = createEntry(
	serviceDeskServiceDetailsWithoutProjectRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'service-management.service-details-without-project',
		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskServiceDetailsWithoutProjectContext,
		resources: [...getNavigationResources(), workspaceResource, getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskServiceDetailsWithoutProjectContext],

		meta: {
			reporting: {
				id: 'servicedesk-service-details-without-project',
				packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
				teamName: 'Astral',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
